import com.github.chosamuel.kishibe.math.Vector2

data class Coord(val x: Int, val y: Int)
typealias SpringConfiguration = List<List<List<Coord>>>

fun createSquareSpringConfiguration(sp: SpringParticles2D): SpringConfiguration{
    val cfg = mutableListOf<MutableList<MutableList<Coord>>>()
    sp.forEachIndexed { y, row->
        cfg.add(mutableListOf<MutableList<Coord>>())
        row.forEachIndexed { x, p->
            cfg[y].add(mutableListOf<Coord>())
            //addright
            if(x+1 < sp.size){ cfg[y][x].add(Coord(x+1,y)) }
            //add left
            if(x-1 > -1){ cfg[y][x].add(Coord(x-1,y)) }
            //add top
            if(y-1 > -1){ cfg[y][x].add(Coord(x,y-1))}
            //add bottom
            if(y+1 < sp.size){ cfg[y][x].add(Coord(x,y+1))}
        }
    }
    return cfg
}

fun createDiagonalSpringConfiguration(sp: SpringParticles2D): SpringConfiguration {
    val cfg = mutableListOf<MutableList<MutableList<Coord>>>()
    sp.forEachIndexed { y, row->
        cfg.add(mutableListOf<MutableList<Coord>>())
        row.forEachIndexed { x, p->
            cfg[y].add(mutableListOf<Coord>())
            //RIGHT SIDE
            if(x+1 < sp.size){
                //TOP RIGHT
                if(y-1 > -1){ cfg[y][x].add(Coord(x+1,y-1)) }
                //BOTTOM RIGHT
                if(y+1 < sp.size){ cfg[y][x].add(Coord(x+1,y+1)) }
            }
            //LEFT SIDE
            if(x-1 > -1){
                //TOP LEFT
                if(y-1 > -1){ cfg[y][x].add(Coord(x-1,y-1)) }
                //BOTTOM LEFT
                if(y+1 < sp.size){ cfg[y][x].add(Coord(x-1,y+1)) }
            }
        }
    }
    return cfg
}

fun calculateSpringForces(
    sp: SpringParticles2D,
    cfg: SpringConfiguration,
    restLength: Double,
    k: Double = 0.05,
    dampening: Double = 3.0
) : List<List<Vector2>>
{
    val forces = mutableListOf<MutableList<Vector2>>()
    sp.forEachIndexed { y, row->
        forces.add(mutableListOf<Vector2>())
        row.forEachIndexed{ x, p->
            var force = Vector2(0.0,0.0)
            cfg[y][x].forEach {
                val x = p.pos.distanceTo(sp[it.y][it.x].pos) - restLength
                force += sp[it.y][it.x].pos
                    .minus(p.pos)
                    .normalized
                    .times(k * x)
            }
            //force /= (cfg[y][x].size*1.0)
            force *= dampening
            forces[y].add(force)
        }
    }

    return forces
}

